import { render } from "./RegisterConfirm.vue?vue&type=template&id=3db7aeaa&scoped=true"
import script from "./RegisterConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterConfirm.vue?vue&type=script&setup=true&lang=js"

import "./RegisterConfirm.vue?vue&type=style&index=0&id=3db7aeaa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db7aeaa"],['__file',"src/views/register/RegisterConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3db7aeaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3db7aeaa', __exports__)) {
    api.reload('3db7aeaa', __exports__)
  }
  
  module.hot.accept("./RegisterConfirm.vue?vue&type=template&id=3db7aeaa&scoped=true", () => {
    api.rerender('3db7aeaa', render)
  })

}


export default __exports__